import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faBasketShopping, faUtensils, faHouse, faCar, faCouch, faShirt, faFilm, faChildren, faPaw, faHeartPulse, faPiggyBank, faArrowTrendUp, faRightLeft, faLayerGroup, faWallet } from "@fortawesome/free-solid-svg-icons";
import type { BackendTransaction } from "../../types/receiptTypes";
import { bankClassification, money } from "../../domain/transactionDetail";

const categories: Record<string, { icon: IconDefinition; color: string }> = {
  "Groceries": { icon: faBasketShopping, color: "text-emerald-700" },
  "Dining & Takeaway": { icon: faUtensils, color: "text-orange-600" },
  "Housing & Utilities": { icon: faHouse, color: "text-blue-700" },
  "Transportation": { icon: faCar, color: "text-indigo-700" },
  "Household & Supplies": { icon: faCouch, color: "text-teal-700" },
  "Personal Care & Clothes": { icon: faShirt, color: "text-pink-700" },
  "Entertainment & Leisure": { icon: faFilm, color: "text-purple-700" },
  "Kids & Family": { icon: faChildren, color: "text-amber-700" },
  "Pets": { icon: faPaw, color: "text-lime-700" },
  "Health & Wellness": { icon: faHeartPulse, color: "text-rose-700" },
  "Financial & Future": { icon: faPiggyBank, color: "text-cyan-700" },
};

export function transactionIcon(row: BackendTransaction) {
  if (row.type === "Income") return { icon: faArrowTrendUp, color: "text-emerald-700", label: "Income" };
  if (row.type === "Transfer") return { icon: faRightLeft, color: "text-blue-700", label: "Transfer" };
  const detail = row.items.filter(item => item.origin !== "AutoGenerated");
  let category = bankClassification(row).category;
  if (detail.length) {
    const totals: Record<string, number> = {};
    for (const item of detail) {
      const name = item.category || "Unknown";
      totals[name] = money((totals[name] || 0) + item.totalPrice);
    }
    const highest = Math.max(...Object.values(totals));
    const leaders = Object.keys(totals).filter(name => totals[name] === highest);
    if (leaders.length > 1) return { icon: faLayerGroup, color: "text-violet-700", label: "Expense · Mixed" };
    category = leaders[0];
  }
  return categories[category] ? { ...categories[category], label: `Expense · ${category}` }
    : { icon: faWallet, color: "text-slate-600", label: "Expense" };
}
